import { Controller } from "@hotwired/stimulus";

/**
 * Keeps the main shell margin in sync with the fixed sidebar width:
 * collapsed 72px → expanded 288px (matches .sidebar-nav.expanded in sidebar_nav.css).
 */
export default class extends Controller {
  observer = null;

  connect() {
    this._sync = this._sync.bind(this);
    this.sidebar = document.getElementById("sidebar-nav");
    if (!this.sidebar) return;

    this.observer = new MutationObserver(this._sync);
    this.observer.observe(this.sidebar, {
      attributes: true,
      attributeFilter: ["class"],
    });
    window.addEventListener("resize", this._sync);
    this._sync();
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    window.removeEventListener("resize", this._sync);
    this.element.style.marginLeft = "";
  }

  _sync() {
    if (!this.sidebar) return;

    if (window.innerWidth < 1024) {
      this.element.style.marginLeft = "";
      return;
    }

    const expanded = this.sidebar.classList.contains("expanded");
    this.element.style.marginLeft = expanded ? "288px" : "72px";
  }
}
